import React from "react";
import { SectionIntro as StyledSectionIntro } from "./styles";

interface SectionIntroType {}

export const SectionIntro: React.FC<SectionIntroType> = ({ children }) => (
  <StyledSectionIntro>{children}</StyledSectionIntro>
);
